export default __webpack_public_path__ + "static/media/KZ.М.12.1633.3072f94a.svg";